"use strict";

var _classCallCheck = require("/Users/JamesMontes/Documents/MobileApps/majocobos/majocobos/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/JamesMontes/Documents/MobileApps/majocobos/majocobos/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/Users/JamesMontes/Documents/MobileApps/majocobos/majocobos/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/Users/JamesMontes/Documents/MobileApps/majocobos/majocobos/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PolygonDrawer = void 0;

var PolygonDrawerBase_1 = require("./PolygonDrawerBase");

var PolygonDrawer = /*#__PURE__*/function (_PolygonDrawerBase_1$) {
  _inherits(PolygonDrawer, _PolygonDrawerBase_1$);

  var _super = _createSuper(PolygonDrawer);

  function PolygonDrawer() {
    _classCallCheck(this, PolygonDrawer);

    return _super.apply(this, arguments);
  }

  _createClass(PolygonDrawer, [{
    key: "getSidesData",
    value: function getSidesData(particle, radius) {
      var _a, _b;

      var polygon = particle.shapeData;
      var sides = (_b = (_a = polygon === null || polygon === void 0 ? void 0 : polygon.sides) !== null && _a !== void 0 ? _a : polygon === null || polygon === void 0 ? void 0 : polygon.nb_sides) !== null && _b !== void 0 ? _b : 5;
      return {
        count: {
          denominator: 1,
          numerator: sides
        },
        length: radius * 2.66 / (sides / 3)
      };
    }
  }, {
    key: "getCenter",
    value: function getCenter(particle, radius) {
      var sides = this.getSidesCount(particle);
      return {
        x: -radius / (sides / 3.5),
        y: -radius / (2.66 / 3.5)
      };
    }
  }]);

  return PolygonDrawer;
}(PolygonDrawerBase_1.PolygonDrawerBase);

exports.PolygonDrawer = PolygonDrawer;